import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { calculateRanges } from './helpers';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import ArrowRight from '@wix/da-ds/pkg/Icons/ArrowRight';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Page from './_partials/Page';
import Dots from './_partials/Dots';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './Pagination.scss';
const Pagination = ({ currentPage, totalPages, pageSize, showPageNumbers = true, onChangePage, getPageUrl })=>{
    const { t } = useTranslation();
    if (totalPages < 2) {
        return null;
    }
    const { startingBlock, showStartDots, midBlock, showEndDots, endBlock } = calculateRanges(currentPage, totalPages);
    const renderButton = (n)=>/*#__PURE__*/ React.createElement(Page, {
            key: n,
            page: n,
            isCurrent: n === currentPage,
            getPageUrl: getPageUrl,
            onChangePage: onChangePage,
            biData: BiData({
                evid: 113,
                direction: `${n}`,
                thumbs_per_page: pageSize
            })
        }, n);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, currentPage > 1 && /*#__PURE__*/ React.createElement(Page, {
        page: currentPage - 1,
        isCurrent: false,
        onChangePage: onChangePage,
        getPageUrl: getPageUrl,
        biData: BiData({
            evid: 113,
            direction: 'previous',
            thumbs_per_page: pageSize
        })
    }, /*#__PURE__*/ React.createElement(ArrowLeft, {
        size: IconSize.MEDIUM,
        disableDefaultColors: true,
        className: classnames(s['arrow'], s['prev'])
    }), t('pagination.prev')), showPageNumbers && /*#__PURE__*/ React.createElement(React.Fragment, null, startingBlock.map(renderButton), showStartDots && /*#__PURE__*/ React.createElement(Dots, {
        pageSize: pageSize,
        totalPages: totalPages,
        onChangePage: onChangePage,
        getPageUrl: getPageUrl
    }), midBlock.map(renderButton), showEndDots && /*#__PURE__*/ React.createElement(Dots, {
        pageSize: pageSize,
        totalPages: totalPages,
        onChangePage: onChangePage,
        getPageUrl: getPageUrl
    }), endBlock.map(renderButton)), currentPage < totalPages && /*#__PURE__*/ React.createElement(Page, {
        page: currentPage + 1,
        isCurrent: false,
        onChangePage: onChangePage,
        getPageUrl: getPageUrl,
        biData: BiData({
            evid: 113,
            direction: 'next',
            thumbs_per_page: pageSize
        })
    }, t('pagination.next'), /*#__PURE__*/ React.createElement(ArrowRight, {
        size: IconSize.MEDIUM,
        disableDefaultColors: true,
        className: classnames(s['arrow'], s['next'])
    })));
};
Pagination.displayName = 'Pagination';
export default Pagination;
